import { WidgetProps } from '@rjsf/core';

const CustomSelect = (props: WidgetProps) => {
    const { label, value, options, onChange } = props;

    const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        e.preventDefault();
        onChange(e.target?.value);
    };

    const enumOptions: any = options && options.enumOptions;

    return (
        <div className="custom-select">
            <label className="select-label">{label}</label>
            <select
                data-testId="custom-select"
                className="custom-select-input"
                onChange={handleChange}
                defaultValue={value}
            >
                {enumOptions.length > 0 &&
                    enumOptions.map((opt: any, i: number) => (
                        <option key={`${opt.label}-${i}`} id={opt.label} value={opt.value}>
                            {opt.label}
                        </option>
                    ))}
            </select>
        </div>
    );
};

export default CustomSelect;
